import { useModuleContext } from '../contexts/module'
import AttachmentsInfo from './AttachmentsInfo'
import { getDimensions } from '@utils/catalog'
import { dimensions } from '@constants/catalog'
import ReadMoreWithCSSClamp from '@components/ReadmoreWithCSSClamp'
import useIsIdFoundInURL from '@hooks/useIsIdFoundInURL'

const ArtworkInfo = () => {
  const { state: { labels, artworkInformation } } = useModuleContext()
  const {
    id,
    medium,
    material,
    description,
    artworkSizeLabel,
    width,
    height,
    depth,
    labelCm,
    labelInch,
    unitMeasure,
    durationInMinute,
    weight,
    volumeInCubicMetre,
    edition,
    framedDepth,
    framedHeight,
    framedUnitMeasure,
    framedWidth,
    artworkSizeWithFrameLabel,
    showMeasures
  } = artworkInformation || {}

  // Overengineered? way of detecting if the data loaded finally corresponds to the data in URL
  // Can be used as a final check for "data ready"
  const isDataReady = useIsIdFoundInURL(id)
  return (
    <div className='' >
      <div className='row'>
        {/* <!-- Description --> */}
        <div className='col-12 order-lg-2'>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a className='anchor position-absolute' id='artwork-description'>&nbsp;</a>
          <div className=''>
            <h3 className='color-black mb-2 mb-lg-3 h5'>
              {labels?.ShowRoomArtwork?.introDescriptionLabel}
            </h3>
            {isDataReady &&
              <ReadMoreWithCSSClamp
                labels={{
                  unfoldText: `+ ${labels?.OnlineShowRoom?.btnExpandRoomDescrLabel}`,
                  foldText: `- ${labels?.OnlineShowRoom?.btnCollapseRoomDescrLabel}`
                }}
                text={description || ''}
              />}
          </div>
        </div>

        {/* <!-- Artwork Details --> */}
        <div className='col-12 order-lg-1 mb-lg-8'>
          <div className='row'>
            {/* <!-- Detail --> */}
            <div className='col-12 col-md-6 mt-8 mt-lg-0'>
              <h3 className='color-black artwork-more-info h5'>{labels?.ShowRoomArtwork?.moreInfoLabel}</h3>
              <div className='mt-3 me-5 mb-0 ms-0'>
                <div>
                  {!!medium && <div className='text-medium color-black'>{medium}</div>}
                  {!!material && <div className='text-medium color-black'>{material}</div>}
                  {!!edition && (
                    <div className='text-medium color-black'>
                      {edition.includes('Edition') ? edition : `${labels?.ArtworkUploader?.editionLabel} ${edition}`}
                    </div>
                  )}
                </div>
                <div className='mt-lg-9'>
                  <>
                    {showMeasures ? (
                      <>
                        {!!height && !!width &&
                          <>
                            <div className='text-medium color-black mt-8'>{artworkSizeLabel}</div>
                            <div className='text-medium color-black'>
                              {
                              // @ts-ignore
                              getDimensions(height, width, depth, unitMeasure, dimensions.cm, labelCm)}
                            </div>
                            <div className='text-medium color-black'>
                              {getDimensions(
                                height,
                                width,
                                // @ts-ignore
                                depth,
                                unitMeasure,
                                dimensions.inches,
                                labelInch)}
                            </div>
                          </>
                        }
                        {framedHeight && framedWidth && framedUnitMeasure &&
                          <div className='pt-5'>
                            <div className='text-medium color-black'>{artworkSizeWithFrameLabel}</div>
                            <div className='text-medium color-black'>
                              {getDimensions(framedHeight,
                                framedWidth,
                                // @ts-ignore
                                framedDepth,
                                framedUnitMeasure.toLowerCase(),
                                dimensions.cm,
                                labelCm)}
                            </div>
                            <div className='text-medium color-black'>
                              {getDimensions(framedHeight,
                                framedWidth,
                                // @ts-ignore
                                framedDepth,
                                framedUnitMeasure.toLowerCase(),
                                dimensions.inches,
                                labelInch)}
                            </div>
                          </div>
                        }
                      </>
                    ) : null}
                  </>
                  {!!durationInMinute &&
                    <div className='text-medium color-black'>{durationInMinute}</div>
                  }
                  {!!weight &&
                    <div className='text-medium color-black'>{weight}</div>
                  }
                  {!!volumeInCubicMetre &&
                    <div className='text-medium color-black'>{volumeInCubicMetre}</div>
                  }
                </div>
              </div>
            </div>
            <AttachmentsInfo />
          </div>
        </div>
      </div>
    </div >
  )
}

export default ArtworkInfo